import { createSelector } from 'reselect';
import { REQS_PAGE_LIST } from './constants';

export const getTabsSelector = () => createSelector([], () => REQS_PAGE_LIST);
